module.exports = __webpack_public_path__ + "static/media/fondo-finca.88737056.jpg";